import moment from'moment';import {Realms,getCurrentLanguage}from'@wotfe/l10n';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}var _defaultFormats, _formatsByRealms;
var defaultFormats = (_defaultFormats = {}, _defineProperty(_defaultFormats, Realms.RU, {
  shortDate: 'DD.MM.YYYY',
  fullDate: 'D MMMM YYYY [г.]',
  fullMonth: 'D MMMM',
  dayMonth: 'DD.MM',
  time: 'HH:mm',
  datetime: 'DD.MM.YYYY HH:mm',
  decimal: ',',
  thousand: ' ',
  percent: '%'
}), _defineProperty(_defaultFormats, Realms.EU, {
  shortDate: 'DD/MM/YYYY',
  fullDate: 'D MMMM YYYY',
  fullMonth: 'D MMMM',
  dayMonth: 'DD/MM',
  time: 'HH:mm',
  datetime: 'DD/MM/YYYY HH:mm',
  decimal: '.',
  thousand: ',',
  percent: '%'
}), _defineProperty(_defaultFormats, Realms.NA, {
  shortDate: 'MM/DD/YYYY',
  fullDate: 'MMMM D, YYYY',
  fullMonth: 'MMMM D',
  dayMonth: 'MM/DD',
  time: 'h:mm a',
  datetime: 'MM/DD/YYYY h:mm a',
  decimal: '.',
  thousand: ',',
  percent: '%'
}), _defineProperty(_defaultFormats, Realms.ASIA, {
  shortDate: 'MM/DD/YYYY',
  fullDate: 'MMMM D, YYYY',
  fullMonth: 'MMMM D',
  dayMonth: 'MM/DD',
  time: 'h:mm a',
  datetime: 'MM/DD/YYYY h:mm a',
  decimal: '.',
  thousand: ',',
  percent: '%'
}), _defineProperty(_defaultFormats, Realms.KR, {
  shortDate: 'MM/DD/YYYY',
  fullDate: 'MMMM D, YYYY',
  fullMonth: 'MMMM D',
  dayMonth: 'MM/DD',
  time: 'h:mm a',
  datetime: 'MM/DD/YYYY h:mm a',
  decimal: '.',
  thousand: ',',
  percent: '%'
}), _defineProperty(_defaultFormats, Realms.CN360, {
  shortDate: 'YYYY-MM-DD ',
  fullDate: 'YYYY[年]M[月]D[日]',
  fullMonth: 'M[月]D[日]',
  dayMonth: 'MM-DD',
  time: 'H:mm',
  datetime: 'YYYY-MM-DD H:mm',
  decimal: '.',
  thousand: ',',
  percent: '%'
}), _defaultFormats);
var formatsByRealms = (_formatsByRealms = {}, _defineProperty(_formatsByRealms, Realms.CT, {
  ru: defaultFormats.ru,
  en: defaultFormats.eu
}), _defineProperty(_formatsByRealms, Realms.RU, {
  ru: defaultFormats.ru,
  be: defaultFormats.ru,
  kk: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D MMMM, YYYY',
    fullMonth: 'D MMMM',
    dayMonth: 'DD.MM',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  uk: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D MMMM YYYY [р.]',
    fullMonth: 'D MMMM',
    dayMonth: 'DD.MM',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  }
}), _defineProperty(_formatsByRealms, Realms.EU, {
  en: defaultFormats.eu,
  ru: defaultFormats.ru,
  kk: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D MMMM, YYYY',
    fullMonth: 'D MMMM',
    dayMonth: 'DD.MM',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  uk: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D MMMM YYYY [р.]',
    fullMonth: 'D MMMM',
    dayMonth: 'DD.MM',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  bg: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  cs: {
    shortDate: 'D.M. YYYY',
    fullDate: 'D. MMMM YYYY',
    fullMonth: 'D. MMMM',
    dayMonth: 'D. M.',
    time: 'HH:mm',
    datetime: 'D.M. YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  da: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  de: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D. MMMM YYYY',
    fullMonth: 'D. MMMM',
    dayMonth: 'DD.MM.',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  el: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  es: {
    shortDate: 'D/M/YYYY',
    fullDate: 'D [de] MMMM [de] YYYY',
    fullMonth: 'D [de] MMMM',
    dayMonth: 'D/M',
    time: 'H:mm',
    datetime: 'D/M/YYYY H:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  et: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'D. MMMM YYYY',
    fullMonth: 'D. MMMM',
    dayMonth: 'DD.MM',
    time: 'H:mm',
    datetime: 'DD.MM.YYYY H:mm',
    decimal: ',',
    thousand: ' ',
    percent: '%'
  },
  fi: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  fr: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: 'DD/MM',
    time: 'H [h] mm',
    datetime: 'DD/MM/YYYY H [h] mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  hr: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  hu: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: 'MM. DD.',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  it: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: ',',
    thousand: '.',
    percent: '%'
  },
  lt: {
    shortDate: 'YYYY-MM-DD',
    fullDate: 'YYYY [m.] MMMM D [d.]',
    fullMonth: 'MMMM D',
    dayMonth: 'MM DD',
    time: 'HH:mm',
    datetime: 'YYYY-MM-DD HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  lv: {
    shortDate: 'DD.MM.YYYY',
    fullDate: 'YYYY. [gada] D. MMMM',
    fullMonth: 'D. MMM',
    dayMonth: 'DD.MM.',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: '%'
  },
  nl: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  no: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  pl: {
    shortDate: 'D.MM.YYYY',
    fullDate: 'D MMMM, YYYY',
    fullMonth: 'D MMMM',
    dayMonth: 'D.MM',
    time: 'HH:mm',
    datetime: 'D.MM.YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: '%'
  },
  pt: {
    shortDate: 'DD/MM/YYYY',
    fullDate: 'D [de] MMMM [de] YYYY',
    fullMonth: 'D [de] MMMM',
    dayMonth: 'DD/MM',
    time: 'H:mm',
    datetime: 'DD/MM/YYYY H:mm',
    decimal: ',',
    thousand: ' ',
    percent: '%'
  },
  ro: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  sr: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  sv: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  tr: {
    shortDate: 'DD/MM/YYYY',
    fullDate: defaultFormats.eu.fullDate,
    fullMonth: defaultFormats.eu.fullMonth,
    dayMonth: defaultFormats.eu.dayMonth,
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: ',',
    thousand: '.',
    percent: '%',
    percentBefore: true
  }
}), _defineProperty(_formatsByRealms, Realms.NA, {
  'en': defaultFormats.na,
  'fr': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.na.fullDate,
    fullMonth: defaultFormats.na.fullMonth,
    dayMonth: defaultFormats.na.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'es-ar': {
    shortDate: 'DD/MM/YYYY',
    fullDate: 'D [de] MMMM [de] YYYY',
    fullMonth: 'D [de] MMMM',
    dayMonth: 'DD/MM',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: ',',
    thousand: ' ',
    percent: ' %'
  },
  'es-mx': {
    shortDate: 'DD/MM/YYYY',
    fullDate: 'D [de] MMMM [del] YYYY',
    fullMonth: 'D [de] MMMM',
    dayMonth: 'DD/MM',
    time: 'HH:mm',
    datetime: 'DD.MM.YYYY HH:mm',
    decimal: '.',
    thousand: ' ',
    percent: ' %'
  },
  'pt-br': {
    shortDate: 'DD/MM/YYYY',
    fullDate: 'D [de] MMMM [de] YYYY',
    fullMonth: 'D [de] MMMM',
    dayMonth: 'DD/MM',
    time: 'H:mm',
    datetime: 'DD/MM/YYYY H:mm',
    decimal: ',',
    thousand: '.',
    percent: '%'
  },
  'ja': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.na.fullDate,
    fullMonth: defaultFormats.na.fullMonth,
    dayMonth: defaultFormats.na.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'ko': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.na.fullDate,
    fullMonth: defaultFormats.na.fullMonth,
    dayMonth: defaultFormats.na.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  }
}), _defineProperty(_formatsByRealms, Realms.ASIA, {
  'en': defaultFormats.asia,
  'ja': {
    shortDate: 'YYYY/MM/DD',
    fullDate: 'YYYY[年]MM[月]DD[日]',
    fullMonth: 'MM[月]DD[日]',
    dayMonth: 'MM[月]DD[日]',
    time: 'HH:mm',
    datetime: 'YYYY/MM/DD HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'vi': {
    shortDate: 'DD/MM/YYYY',
    fullDate: '[ngày] D [tháng] M [năm] YYYY',
    fullMonth: '[ngày] D [tháng] M',
    dayMonth: 'DD/MM',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm',
    decimal: '.',
    thousand: ' ',
    percent: '%'
  },
  'fil': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.asia.fullDate,
    fullMonth: defaultFormats.asia.fullMonth,
    dayMonth: defaultFormats.asia.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'ms': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.asia.fullDate,
    fullMonth: defaultFormats.asia.fullMonth,
    dayMonth: defaultFormats.asia.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'id': {
    shortDate: 'MM/DD/YYYY',
    fullDate: defaultFormats.asia.fullDate,
    fullMonth: defaultFormats.asia.fullMonth,
    dayMonth: defaultFormats.asia.dayMonth,
    time: 'h:mm a',
    datetime: 'MM/DD/YYYY h:mm a',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'th': {
    shortDate: 'D.M.YYYY',
    fullDate: 'D MMMM YYYY',
    fullMonth: 'D MMMM',
    dayMonth: 'D/M',
    time: 'H:mm',
    datetime: 'D.M.YYYY H:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'ko': {
    shortDate: 'YYYY/M/D',
    fullDate: 'YYYY[년] M[월] D[일]',
    fullMonth: 'M[월] D[일]',
    dayMonth: 'M/D',
    time: 'HH:mm',
    datetime: 'YYYY/M/D HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'zh-cn': {
    shortDate: 'YYYY-MM-DD ',
    fullDate: 'YYYY[年]M[月]D[日]',
    fullMonth: 'M[月]D[日]',
    dayMonth: 'MM-DD',
    time: 'H:mm',
    datetime: 'YYYY-MM-DD H:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  },
  'zh-sg': {
    shortDate: 'YYYY/MM/DD',
    fullDate: 'YYYY[年]M[月]D[日]',
    fullMonth: 'M[月]D[日]',
    dayMonth: 'MM/DD',
    time: 'HH:mm',
    datetime: 'YYYY/MM/DD HH:mm',
    decimal: '.',
    thousand: '',
    percent: '%'
  },
  'zh-tw': {
    shortDate: 'YYYY/MM/DD',
    fullDate: 'YYYY [年] MM [月] DD [日]',
    fullMonth: 'M [月] D [日]',
    dayMonth: 'MM/DD',
    time: 'HH:mm',
    datetime: 'YYYY/MM/DD HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  }
}), _defineProperty(_formatsByRealms, Realms.KR, {
  en: defaultFormats.kr,
  ko: {
    shortDate: 'YYYY/M/D',
    fullDate: 'YYYY[년] M[월] D[일]',
    fullMonth: 'M[월] D[일]',
    dayMonth: 'M/D',
    time: 'HH:mm',
    datetime: 'YYYY/M/D HH:mm',
    decimal: '.',
    thousand: ',',
    percent: '%'
  }
}), _defineProperty(_formatsByRealms, Realms.CN360, {
  'zh-cn': defaultFormats.cn360
}), _formatsByRealms);
var FormatsManager = /*#__PURE__*/function () {
  function FormatsManager() {
    _classCallCheck(this, FormatsManager);
  }

  _createClass(FormatsManager, null, [{
    key: "initializeFormats",
    value: function initializeFormats(realm, lang) {
      var localeSpecification = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      FormatsManager.currentRealm = realm.toLowerCase();
      FormatsManager.currentLang = lang.toLowerCase();
      FormatsManager.currentFormats = FormatsManager.getFormatsForLanguage(FormatsManager.currentRealm, FormatsManager.currentLang);
      moment.updateLocale(FormatsManager.currentLang, localeSpecification);
    }
  }, {
    key: "getFormats",
    value: function getFormats() {
      return FormatsManager.currentFormats;
    }
  }]);

  return FormatsManager;
}();

FormatsManager.getFormatsForLanguage = function (realm, lang) {
  realm = realm && realm.toLowerCase();

  if (realm && formatsByRealms[realm]) {
    return lang && formatsByRealms[realm][lang.toLowerCase()] || defaultFormats[realm];
  }

  return defaultFormats[Realms.EU];
};var formats$1 = function formats() {
  return FormatsManager.getFormats();
};

var DEFAULT_ERROR = '- -';
var ROMANS = ['N', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX'];

var wgsdkThousands = function wgsdkThousands(value) {
  var formatsData = formats$1();
  var dotted = '';
  var number = typeof value === 'string' ? value : value.toString();
  var dotPosition = number.search(/\./);

  if (dotPosition > -1) {
    dotted = ',';

    if (formatsData) {
      dotted = formatsData.decimal || '.';
    }

    dotted += number.substr(dotPosition + 1);
    number = number.substr(0, dotPosition);
  }

  var sign = '';

  if (number.charAt(0) === '-') {
    number = number.substr(1);
    sign = '-';
  }

  var len = number.length;
  var separator = ' ';

  if (formatsData && formatsData.thousand) {
    separator = formatsData.thousand;
  }

  var result = '';

  for (var i = 0; i < len; ++i) {
    if (i !== 0 && len - i !== 0 && (len - i) % 3 === 0) {
      result += separator;
    }

    result += number.charAt(i);
  }

  return sign + result + dotted;
};

var compactNumber = function compactNumber(value) {
  var reduceStartFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  var number = typeof value === 'string' ? parseInt(value, 10) : value;

  if (isNaN(number)) {
    return DEFAULT_ERROR;
  }

  var suffix = '';

  if (reduceStartFrom < 10000) {
    reduceStartFrom = 10000;
  }

  if (number >= reduceStartFrom) {
    if (number >= 1000000) {
      number = number / 1000000;
      suffix = ' M';
    } else {
      number = number / 1000;
      suffix = ' K';
    }
  }

  if (suffix) {
    number = Math.floor(number * 100) / 100;
  }

  var result = suffix ? number.toFixed(2) : number.toString();
  return wgsdkThousands(result) + suffix;
};
var thousands = function thousands(value, roundDown) {
  var newValue = typeof value === 'string' ? parseFloat(value) : value;
  newValue = roundDown ? Math.floor(newValue) : Math.round(newValue);

  if (isNaN(newValue)) {
    return DEFAULT_ERROR;
  }

  return wgsdkThousands(newValue.toString());
};
var floats = function floats(value) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var newValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(newValue)) {
    return DEFAULT_ERROR;
  }

  return wgsdkThousands(round(newValue, digits).toString());
};
var formatPercent = function formatPercent(value) {
  var formatting = formats$1();
  var percent = formatting ? formatting.percent : '%';
  var isPercentBefore = formatting && formatting.percentBefore;
  var parsedValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(parsedValue)) {
    return DEFAULT_ERROR;
  }

  var text = wgsdkThousands(value);
  text = isPercentBefore ? "".concat(percent).concat(text) : "".concat(text).concat(percent);
  return text;
};
var percent = function percent(value) {
  var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var parsedValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(parsedValue)) {
    return DEFAULT_ERROR;
  }

  parsedValue = parseFloat(parsedValue.toFixed(fixed));
  return formatPercent(parsedValue.toString());
};
var percentFloatToFixed = function percentFloatToFixed(value) {
  var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var parsedValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(parsedValue)) {
    return DEFAULT_ERROR;
  }

  return formatPercent(parsedValue.toFixed(fixed));
};
var toRoman = function toRoman(value) {
  return ROMANS[value];
};
var toArabic = function toArabic(value) {
  return ROMANS.indexOf(value);
};
var round = function round(value, ndigits) {
  var shift = Math.pow(10, ndigits);
  return Math.round(value * shift) / shift;
};
var floatToFixed = function floatToFixed(value) {
  var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var parsedValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(parsedValue)) {
    return DEFAULT_ERROR;
  }

  return wgsdkThousands(parsedValue.toFixed(fixed));
};var formats = function formats() {
  return FormatsManager.getFormats();
};

var THAI_LANGUAGE_CODE = 'th';
var THAI_YEAR_OFFSET = 543;

var shiftThaiYear = function shiftThaiYear(momentObj) {
  return getCurrentLanguage() === THAI_LANGUAGE_CODE ? moment(momentObj).add(THAI_YEAR_OFFSET, 'year') : momentObj;
};

var isoToLocalFormattedDateByFormat = function isoToLocalFormattedDateByFormat(isoString, format) {
  return shiftThaiYear(moment.utc(isoString)).local().format(format);
};

var isoToFormattedLocalDateTime = function isoToFormattedLocalDateTime(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().datetime);
};
var isoToFormattedLocalDate = function isoToFormattedLocalDate(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().shortDate);
};
var isoToFormattedLocalFullDate = function isoToFormattedLocalFullDate(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().fullDate);
};
var isoToFormattedLocalDayMonth = function isoToFormattedLocalDayMonth(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().dayMonth);
};
var isoToFormattedLocalFullMonth = function isoToFormattedLocalFullMonth(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().fullMonth);
};
var isoToFormattedLocalTime = function isoToFormattedLocalTime(isoString) {
  return isoToLocalFormattedDateByFormat(isoString, formats().time);
};

var unixToFormattedLocalDateByFormat = function unixToFormattedLocalDateByFormat(timestamp, format) {
  return shiftThaiYear(moment.unix(timestamp)).local().format(format);
};

var unixToFormattedLocalDateTime = function unixToFormattedLocalDateTime(timestamp) {
  return unixToFormattedLocalDateByFormat(timestamp, formats().datetime);
};
var unixToFormattedLocalDate = function unixToFormattedLocalDate(timestamp) {
  return unixToFormattedLocalDateByFormat(timestamp, formats().shortDate);
};
var unixToFormattedLocalDayMonth = function unixToFormattedLocalDayMonth(timestamp) {
  return unixToFormattedLocalDateByFormat(timestamp, formats().dayMonth);
};
var unixToFormattedLocalTime = function unixToFormattedLocalTime(timestamp) {
  return unixToFormattedLocalDateByFormat(timestamp, formats().time);
};
var getShiftedIsoString = function getShiftedIsoString(seconds) {
  return seconds ? moment().add(seconds, 'seconds').toISOString() : null;
};
var daysSinceDate = function daysSinceDate(date) {
  return moment().diff(moment(date).local(), 'days');
};

var getDurationSinceTimestamp = function getDurationSinceTimestamp(timestamp) {
  var date = moment.unix(timestamp).local();
  return moment.duration(moment().diff(date));
};

var findLocalizedDuration = function findLocalizedDuration(duration, localizations) {
  var keys = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];
  var type = keys.find(function (step) {
    return !!duration[step]();
  });
  return localizations[type](duration[type]());
};

var getTimeSinceTimestamp = function getTimeSinceTimestamp(timestamp, localizations) {
  var duration = getDurationSinceTimestamp(timestamp);
  return findLocalizedDuration(duration, localizations);
};
var isDateAfter = function isDateAfter(date) {
  var compareTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return moment.utc(date).isAfter(moment.utc(compareTo));
};
var formatDateAgoWith = function formatDateAgoWith(date, translations) {
  var momentObj = moment(date);

  if (momentObj.clone().local().isSame(moment(), 'day')) {
    return translations.today;
  } else if (momentObj.clone().local().isSame(moment().add(1, 'days'), 'day')) {
    return translations.tomorrow;
  }

  return isoToFormattedLocalDate(date);
};export{DEFAULT_ERROR,FormatsManager,ROMANS,compactNumber,daysSinceDate,floatToFixed,floats,formatDateAgoWith,formatPercent,getShiftedIsoString,getTimeSinceTimestamp,isDateAfter,isoToFormattedLocalDate,isoToFormattedLocalDateTime,isoToFormattedLocalDayMonth,isoToFormattedLocalFullDate,isoToFormattedLocalFullMonth,isoToFormattedLocalTime,percent,percentFloatToFixed,round,thousands,toArabic,toRoman,unixToFormattedLocalDate,unixToFormattedLocalDateTime,unixToFormattedLocalDayMonth,unixToFormattedLocalTime};//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wotfe/formatters/dist/index.esm.js
// module id = 801
// module chunks = 16